import { useEffect, useState } from "react";
import { Paper, Button, Table, TableBody, Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { useSnackbar } from "notistack";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { DeletePopUp, PageLoader, Pagination, STableLoader } from "../../../../shared_elements";
import { SecurityAgainstList, SecurityAgainstCRU } from "../components";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { checkApiStatus } from "../../../../utils";
import { getSecurityAgainstListApi, deleteSecurityAgainstApi } from "../apiServices";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { ButtonLoader } from "../../../../shared_elements/components";
import { trackActivity } from "../../../../utils/mixpanel";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import { PermissionWrapper } from "../../../../wrappers";
import SettingPageLayout from "../../../elements/SettingPageLayout";
import { RoleBaseAccess } from "../../../../hoc";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const SecurityAgainstHeader = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Security Against`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )

    }
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['D'] }}>
                        <Checkbox color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ width: "200px", whiteSpace: "nowrap"}}> {tableSorting('name', 'Name')}</TableCell>
                <TableCell sx={{ minWidth: "200px", whiteSpace: "nowrap"}}> {tableSorting('remarks', 'Remarks')}</TableCell>
            </TableRow>
        </TableHead>
    )
}

const SecurityAgainst = () => {
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [securityAgainstInfo, setSecurityAgainstInfo] = useState({ list: [], pagination: {} });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [securityAgainstCRU, setSecurityAgainstCRU] = useState({ modal: false, data: null, mode: '' });
    const [deleteSecurityAgainst, setDeleteSecurityAgainst] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const[isExport,seIsExport]=useState(false)

    useEffect(() => {
        getSecurityAgainstList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed', { page_title: 'Security Against' })
    }, [])

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getSecurityAgainstList('pageLoader', { ...sortQuery, per_page: securityAgainstInfo?.pagination?.per_page });
    }

    const getSecurityAgainstList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getSecurityAgainstListApi(query)).then(response => {
            if (checkApiStatus(response)) {
                setSecurityAgainstInfo(response?.data?.data);
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            }
        })
    }

    const deleteSecurityAgainstFn = () => {
        setLoading(true);
        const idsToDelete = deleteSecurityAgainst?.modal && deleteSecurityAgainst?.data?.id ? [deleteSecurityAgainst?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteSecurityAgainstApi(), { ids: idsToDelete })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Security Against`, success_msg: response?.data?.message, item_ids: deleteSecurityAgainst?.data || bulk?.ids, response: response?.data })
                    setDeleteSecurityAgainst({ modal: false, data: null });
                    setBulk({ modal: false, ids: [], title: '', type: '' });
                    setLoading(false);
                    getSecurityAgainstList('pageLoader', { per_page: securityAgainstInfo?.pagination?.per_page });
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Security Against`, error_msg: response?.data?.message, item_ids: deleteSecurityAgainst?.data || bulk?.ids, response: response?.data })
                }
            })
    }

    const handleExport = () => {
        let query = { export: true }
    if (sortInfo?.sort && sortInfo?.sort_by) {
      query = {
        ...query,
        sort: sortInfo?.sort,
        sort_by: sortInfo?.sort_by
      }
    }
        seIsExport(true);
        globalGetService(getSecurityAgainstListApi(query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Security Against`, page_type: page_type, })
    }
    return (
        <SettingPageLayout
            actionBar={
                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '5px 0px' }}>
                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: "", type: "global" } })} /> </li>
                    {
                        bulk?.type && bulk?.ids?.length ?
                            <>
                                <li className='lease-mobile-button'>
                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                </li>
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['D'] }}>
                                    <li className='lease-mobile-button'>
                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                    </li>
                                </PermissionWrapper>
                            </> : null
                    }
                    {securityAgainstInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} variant="outlined" size='small' onClick={() => { handleExport(); handleItemClicked('Export Button') }}> Export </Button> </li> : null}
                    <li className='lease-mobile-button'>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['C'] }}>
                            <Button variant="contained" color="primary" size='small' startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' onClick={() => { setSecurityAgainstCRU({ modal: true, data: null, mode: 'add' }); handleItemClicked('Add Item Button') }}>Add Security Against</Button>
                        </PermissionWrapper>
                    </li>
                </ul>
            }
        >
            <Paper className="lease-detail-table table-container lease-module-paper" elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 138px)', height: securityAgainstInfo?.list?.length > 0 ? 'calc(100vh - 138px) !important' : 'auto !important', }} >
                <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                    {skeletonLoader ? <STableLoader count={4} rowCount={12} /> : (
                        <Table className='mui-table-format' stickyHeader >
                            <SecurityAgainstHeader
                                item={securityAgainstInfo?.list}
                                bulk={bulk}
                                toggleBulkOps={toggleBulkOps}
                                sortInfo={sortInfo}
                                createSortHandler={createSortHandler} />
                            <TableBody>
                                {securityAgainstInfo?.list?.length > 0 && securityAgainstInfo?.list?.map((item, index) =>
                                    <SecurityAgainstList
                                        key={index}
                                        item={item}
                                        bulk={bulk}
                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                        onEditFn={() => setSecurityAgainstCRU({ modal: true, data: item, mode: 'edit' })}
                                        onView={() => setSecurityAgainstCRU({ modal: true, data: item, mode: 'view' })}
                                        ondeleteSecurityAgainstFn={() => {
                                            setDeleteSecurityAgainst({ modal: true, data: item, });
                                            setBulk({ modal: false, ids: [item], title: '', type: '' })
                                        }}
                                        toggleBulkOps={toggleBulkOps}
                                    />
                                )}
                            </TableBody>
                        </Table>
                    )}
                    {!skeletonLoader && securityAgainstInfo?.list?.length === 0 && <NoRecordFound />}
                </div>
                <Paper square>
                    <Pagination
                        pagination={securityAgainstInfo?.pagination}
                        onPageChange={(event, newPage) => { const pageNum = newPage + 1; getSecurityAgainstList("pageLoader", { page: pageNum, per_page: securityAgainstInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                        onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getSecurityAgainstList("pageLoader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                    />
                </Paper>
            </Paper>
            {securityAgainstCRU.modal &&
                <SecurityAgainstCRU
                    securityAgainstCRU={securityAgainstCRU}
                    modeType={securityAgainstCRU?.mode}
                    getResponseBack={() => {getSecurityAgainstList("", { per_page: securityAgainstInfo?.pagination?.per_page}); setBulk({ modal: false, ids: [], title: '', mode: [] })}}
                    onToggleModal={() => setSecurityAgainstCRU({ modal: false, data: null, mode: '' })}
                />
            }
            {deleteSecurityAgainst.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deleteSecurityAgainst.modal}
                    title={bulk.modal ? (bulk?.ids?.length > 0 && bulk?.ids?.length === (securityAgainstInfo?.list?.length || 0) ? "Delete All Security Against" : "Delete Selected Security Against") : "Delete Security Against"}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => bulk.modal ? setBulk({ modal: false, ids: [] }) : ( setDeleteSecurityAgainst({ modal: false, data: null }), setBulk({ modal: false, ids: [], title: '', type: '' }) ) }
                    onDeleteRecords={() => deleteSecurityAgainstFn()}
                /> : null}
            { revisionHistory.modal &&  
                <RevisionHistory 
                  moduleName={"security_deposit_against"}
                  revisionHistory={revisionHistory}
                  onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
               />
            }
            {isLoading ? <PageLoader /> : null}
        </SettingPageLayout>
    )

};
export default RoleBaseAccess(SecurityAgainst, { application: 'lease_revamp', feature: 'security_deposit', operationType: ['R'], settingNav: true });
